import { Box, IconButton } from "@mui/material";
import { ArrowLeft } from "lucide-react";
import { SidePanel } from "../../components/SidePanel";
import { currencySymbol, money } from "../../lib/format";
import type { Account, TransactionLinkedLeg } from "../../lib/types";

export function LinkedTransferPicker({
  accounts,
  candidates,
  isLoading,
  linkMutation,
  onBack,
  onCloseAll,
}: {
  accounts: Account[];
  candidates: TransactionLinkedLeg[];
  isLoading: boolean;
  linkMutation: { isPending: boolean; mutate: (partnerId: string) => void };
  onBack: () => void;
  onCloseAll: () => void;
}) {
  return (
    <SidePanel ariaLabelledBy="linkPickerTitle" className="link-transaction-picker" open onClose={onBack}>
      {() => (
        <>
          <Box className="records-modal-toolbar">
            <IconButton className="records-icon-button" type="button" aria-label="Back to record" title="Back" onClick={onBack}>
              <ArrowLeft size={18} />
            </IconButton>
            <h2 id="linkPickerTitle">Link a matching record</h2>
            <IconButton className="records-icon-button" type="button" aria-label="Close" title="Close" onClick={onCloseAll}>
              <svg viewBox="0 0 24 24" fill="none" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                <path d="M18 6 6 18"></path>
                <path d="m6 6 12 12"></path>
              </svg>
            </IconButton>
          </Box>
          <Box className="linked-picker-body">
            <p className="linked-picker-hint">Records on another account with the same amount that aren't linked yet.</p>
            {isLoading ? <p className="status">Loading matches…</p> : null}
            {!isLoading && !candidates.length ? <p className="status">No matching records on another account.</p> : null}
            <Box className="linked-picker-list">
              {candidates.map((candidate) => {
                const candidateAccount = accounts.find((item) => item.id === candidate.account_id);
                const outgoing = candidate.type === "expense" || candidate.type === "transfer";
                return (
                  <button
                    key={candidate.id}
                    type="button"
                    className="linked-picker-item"
                    disabled={linkMutation.isPending}
                    onClick={() => linkMutation.mutate(candidate.id)}
                  >
                    <span className="linked-picker-item-main">
                      <strong>{candidate.merchant || candidate.note || "(no description)"}</strong>
                      <span>
                        {candidateAccount?.name || "Account"} ·{" "}
                        {new Date(candidate.occurred_at).toLocaleDateString(undefined, { day: "numeric", month: "short", year: "numeric" })}
                      </span>
                    </span>
                    <span className={outgoing ? "amount-expense" : "amount-income"}>
                      {outgoing ? "−" : "+"}
                      {currencySymbol(candidate.currency)}
                      {money(candidate.amount)}
                    </span>
                  </button>
                );
              })}
            </Box>
          </Box>
        </>
      )}
    </SidePanel>
  );
}
